// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2EmaI","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3ZIwx"};